export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20fashion%20flat%20lay%20with%20black%20combat%20boots%20distressed%20grey%20denim%20silver%20chain%20necklace%20and%20matte%20black%20accessories%20arranged%20on%20dark%20charcoal%20textured%20surface%2C%20dramatic%20side%20lighting%20creating%20strong%20shadows%2C%20edgy%20urban%20street%20style%2C%20moody%20high%20contrast%20editorial%20photography%20with%20industrial%20grunge%20atmosphere&width=1600&height=900&seq=hero-bg-v4&orientation=landscape&nocache=true"
          alt="Basetao Spreadsheet Hub - Fashion and lifestyle products organized beautifully"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/20 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full border border-background-200/50 mb-6">
          <div className="w-4 h-4 flex items-center justify-center text-accent-500">
            <i className="ri-sparkling-line text-sm"></i>
          </div>
          <span className="text-xs font-medium text-foreground-700">
            Trusted Resources for Smarter International Shopping
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 max-w-3xl mx-auto">
          Basetao Spreadsheet &mdash; Complete Guides, Templates &amp; Smart Shopping Tools
        </h1>

        <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-10 max-w-2xl mx-auto">
          Manage your Basetao orders, shipping costs, warehouse data, and product research with powerful spreadsheet resources designed for smarter international shopping.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap"
          >
            Basetao Spreadsheet
            <div className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-primary-600 bg-background-50 hover:bg-background-100 rounded-lg transition-all duration-200 whitespace-nowrap"
          >
            Buy It Now
            <div className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-shopping-cart-line text-sm"></i>
            </div>
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="flex items-center gap-2 text-background-50/80">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-sm text-accent-400"></i>
            </div>
            <span className="text-sm">Order Tracking</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-sm text-accent-400"></i>
            </div>
            <span className="text-sm">Shipping Calculation</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-sm text-accent-400"></i>
            </div>
            <span className="text-sm">Warehouse Management</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-sm text-accent-400"></i>
            </div>
            <span className="text-sm">Cost Optimization</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-sm text-accent-400"></i>
            </div>
            <span className="text-sm">Product Research</span>
          </div>
        </div>
      </div>
    </section>
  );
}